import { on } from '@disy/lib/event-util';

export function setupKeyboardClick() {
  const delegate = '.keyboard-click';
  on(document, 'keydown', forwardToClick('Enter'), { delegate, capture: true });
  on(document, 'keyup', forwardToClick(' '), { delegate, capture: true });

  function forwardToClick(key: string) {
    return (event: KeyboardEvent) => {
      if (event.key === key) {
        event.stopPropagation();
        event.preventDefault();
        (event.target as HTMLElement).click();
      }
    };
  }
}
